import { getApiErrorMessage, isAxiosError } from '../types/error';

/** True when the backend refused because an AI limit is used up (hourly rate limit or daily quota). */
export const isAiQuotaError = (error: unknown): boolean =>
  isAxiosError(error) && error.response?.status === 429;

/** True for the daily AI quota (Faz 10): the 429 says which pool ran out and when it resets. */
export const isAiDailyQuotaError = (error: unknown): boolean =>
  isAiQuotaError(error) && isAxiosError(error) &&
  typeof (error.response?.data as { details?: { quota?: unknown } } | undefined)?.details?.quota === 'string';

/** User-facing text for a failed AI call: the server's daily-quota message, the hourly-limit text, else the
 * server's message. */
export const aiErrorMessage = (error: unknown, quotaText: string, fallback: string): string => {
  if (isAiDailyQuotaError(error)) return getApiErrorMessage(error, quotaText);
  return isAiQuotaError(error) ? quotaText : getApiErrorMessage(error, fallback);
};
